<template>
  <section :id class="overflow-hidden my-spacing-lg">
    <div v-if="cover && cards.length" class="container">
      <div
        class="cards flex flex-col tablet:flex-row"
        :style="{
          '--card-count': cards.length,
        }"
      >
        <div class="card-cover shrink-0 relative z-200 bg-white flex flex-col">
          <div
            class="text-black font-bold leading-none card-cover-title"
            v-html="cover.name"
          />
          <div v-if="cover.url" class="mt-auto">
            <ZtLink class="link with-arrow" :to="cover.url">
              {{ cover.linkTitle || $texts('learnMore', 'Learn more') }}
            </ZtLink>
          </div>
        </div>

        <ParagraphBlokkliFragmentZurichCardWidgetCard
          v-for="(card, i) in cards"
          :key="card.id"
          :index="i"
          v-bind="card"
          :is-active="active === card.id"
          @toggle="onClick(card.id)"
        />
      </div>
    </div>
  </section>
</template>

<script lang="ts" setup>
const { index, siblings, uuid } = defineBlokkliFragment({
  name: 'zurich_card_widget',
  label: 'Zurich Card Widget',
  chunkName: 'rare',
})

const id = useParagraphAnchorId(index, siblings)
const data = await useZurichCardServices()
const active = useState('card-widget-' + uuid, () => '')

const cover = computed(() => data.value[0])
const cards = computed(() => [...data.value].splice(1))

function onClick(id: string) {
  active.value = active.value === id ? '' : id
}
</script>

<style lang="postcss">
.cards {
  --card-aspect-ratio: calc(theme('aspectRatio.card'));
  --card-width: var(--container-width);
  --card-height: calc(var(--card-width) / var(--card-aspect-ratio));
  --card-radius: calc(var(--card-width) / 17);
  --card-title-font-size: calc(var(--card-width) / 16);
  --card-padding: calc(var(--card-width) / 20);

  @screen tablet {
    --card-width: 300px;
    height: var(--card-height);
  }
  @screen desktop {
    --card-width: 330px;
  }
  @screen widescreen {
    --card-width: 375px;
  }
  @screen fullhd {
    --card-width: 400px;
  }

  &:after {
    content: '';
    flex: 0 0 var(--section-padding-x);
    @apply tablet:hidden;
  }
}

.card-cover {
  background-color: #f1f1f1;
  border-radius: var(--card-radius);
  padding: var(--card-padding);
  flex: 0 0 var(--card-height);
  @screen tablet {
    flex: 0 0 var(--card-width);
  }
}

.card-cover-title {
  font-size: calc(var(--card-width) / 5);
}
</style>
